function formatTime (videojs) {
  videojs.setFormatTime(seconds => {
    seconds = seconds < 0 ? 0 : seconds
    let s = Math.floor(seconds % 60)
    let m = Math.floor((seconds / 60) % 60)
    let h = Math.floor(seconds / 3600)

    // handle invalid times
    if (isNaN(seconds) || seconds === Infinity) {
      // '-' is false for all relational operators (e.g. <, >=) so this setting
      // will add the minimum number of fields specified by the guide
      h = m = s = '-'
    }

    // Check if we need to show hours
    h = h > 0 ? h + ':' : ''

    // If hours are showing, we may need to add a leading zero.
    // Always show at least one digit of minutes.
    m = (h && m < 10 ? '0' + m : m) + ':'

    // Check if leading zero is need for seconds
    s = s < 10 ? '0' + s : s

    return h + m + s
  })
}

export default formatTime
